(function(){
    'use strict';

    angular
    .module('app')
    .controller('FormularioController', FormularioController)
 
    FormularioController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function FormularioController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.datos.form = [];
        vm.datos.settings = {};
        vm.datos.settings.from = "";
        vm.datos.settings.asunto = "";
        vm.datos.settings.mailcliente = "";
        vm.datos.settings.msgok = "El mensaje ha sido enviado correctamente.";
        vm.datos.settings.msgko = "El mensaje no ha podido enviarse correctamente, pruebe más tarde.";
        vm.datos.filtros = [];
        vm.fieldName = ""
        vm.editorOptions = {
            lineWrapping : true,
            lineNumbers: true,
            mode: 'xml',
        };


        vm.htmlDecode = function(input){
          var e = document.createElement('div');
          e.innerHTML = input;
          return e.childNodes[0].nodeValue;
        }
       
		vm.update = function(){
			var json = angular.toJson(vm.datos);
            //console.log(json);
			$timeout(function(){
				$('#'+vm.fieldName+"-jsonform").val(json).trigger("change");
			});
		}

        vm.newFilter = function(){
            if(typeof(vm.datos.filtros) == 'undefined'){
                vm.datos.filtros = new Array();
            }
            var datos = new Object();
            datos.campo = "";
            datos.valor = "";
            datos.email = "";
            //console.log(vm.datos.filtros);
            vm.datos.filtros.push(datos);
            vm.update();
        }

        vm.initVars = function(fieldName,value){
             if(value!=""){
               value = vm.htmlDecode(value);
               value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
               value = JSON.parse(value);
               vm.datos = JSON.parse(value);
               //console.log(vm.datos);
            }
            vm.fieldName = fieldName;
        }

        vm.getAllCampos = function(){
            var campos = [];
            for(var cont=0;cont<vm.datos.form.length;cont++){
                for(var cont2=0;cont2<vm.datos.form[cont].columnas.length;cont2++){
                    for(var cont3=0;cont3<vm.datos.form[cont].columnas[cont2].bloques.length;cont3++){
                        if(vm.datos.form[cont].columnas[cont2].bloques[cont3].name!="")
                           campos.push(vm.datos.form[cont].columnas[cont2].bloques[cont3]);
                    }
                }
            }
            return campos;
        }

        vm.borrarFiltro = function(index){
            vm.datos.filtros.splice(index,1);
            vm.update();
        }

        vm.addFila = function(){
            var datos = new Object();
            datos["fila"] = new Object();
            datos["fila"].layout = "1/1";
            datos["columnas"] = new Array();
            datos["columnas"][0] = new Object();
            datos["columnas"][0].medida = 12;
            datos["columnas"][0].medida_tablet = "";
            datos["columnas"][0].medida_mobile = "";
            datos["columnas"][0].layout = "1/1";
            datos["columnas"][0].layout_tablet = "";
            datos["columnas"][0].layout_mobile = "";
            datos["columnas"][0].bloques = new Array();
            vm.datos.form.push(datos);     
            vm.update();      
        }
        vm.borrarFila = function(index){
            vm.datos.form.splice(index,1);
            vm.update();
        }

        vm.modalAjFila = "";
        vm.ajustesFila = function(dato){
            vm.modalAjFila = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'ajustesfilaForm.html',
              size: 'lg',
              controller: function($scope) {
                $scope.dato = dato;
                //console.log(dato);
                $scope.koForm = function(){
                    vm.modalAjFila.close();
                }
                $scope.okForm = function(){
                    vm.modalAjFila.close();
                }
                $scope.selectedColumna = function(dato, selected){
                    return vm.selectedColumna(dato,selected);
                }
                $scope.selectedColumnaTablet = function(dato, selected){
                    return vm.selectedColumnaTablet(dato,selected);
                }
                $scope.selectedColumnaMobile = function(dato, selected){
                    return vm.selectedColumnaMobile(dato,selected);
                }
                $scope.cambiarColumnas = function(dato,value){
                    vm.cambiarColumnas(dato,value);
                }
                $scope.cambiarColumnasTablet = function(dato,value){
                    vm.cambiarColumnasTablet(dato,value);
                }
                $scope.cambiarColumnasMobile = function(dato,value){
                    vm.cambiarColumnasMobile(dato,value);
                }
              }
            });
        }

        vm.borrarBloque = function(data){
            var search = false;
            for(var cont=0;cont<vm.datos.form.length && !search;cont++){
                for(var cont2=0;cont2<vm.datos.form[cont].columnas.length && !search;cont2++){
                    for(var cont3=0;cont3<vm.datos.form[cont].columnas[cont2].bloques.length && !search;cont3++){
                        if(vm.datos.form[cont].columnas[cont2].bloques[cont3] == data){
                            vm.datos.form[cont].columnas[cont2].bloques.splice(cont3, 1);
                            search = true;
                        }
                    }
                }
            }
            vm.update();
        } 

        vm.showColumns = function(dato){
            if(dato.hoverColumns){
                dato.hoverColumns = false;
            }else{
                dato.hoverColumns = true;
            }
        } 
        vm.sortableOptions = {
            handle: '.movimientoform',
            placeholder:'app2',
            stop: function(e, ui) { 
                vm.update();
            },
          }; 
        vm.sortableOptionsBloque = {
            connectWith: ".columnaForm", 
            placeholder: "app", 
            handle:".moverForm", 
            stop: function(e, ui) { 
                vm.update();
            },
          }; 
          
        vm.cambiarColumnas = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length;cont++){
                if(typeof dato.columnas[cont] == 'undefined'){
                    var datoAInsertar = new Object();
                    datoAInsertar.bloques = new Array();
                    dato.columnas.push(datoAInsertar);
                }
                var totalColumnas = 12;

                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
                dato.columnas[cont].medida = division;
                dato.columnas[cont].layout = partesSeparadas[cont];
            }
            dato.fila.layout = value;
            //console.log(value);
            var contSeg = cont;
            for(cont;cont<columnasActuales;cont++){
                for(var contBloq=0;contBloq<dato.columnas[contSeg].bloques.length;contBloq++){
                        dato.columnas[0].bloques.push(dato.columnas[contSeg].bloques[contBloq]);
                }
                dato.columnas.splice(contSeg, 1);
            }
            vm.update();
            //console.log(dato);
        } 
        vm.cambiarColumnasTablet = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length && cont<dato.columnas.length;cont++){
                var totalColumnas = 12;
                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
                
                dato.columnas[cont].medida_tablet = division;
                dato.columnas[cont].layout_tablet = partesSeparadas[cont];
               
            }
            if(partesSeparadas.length<dato.columnas.length){
                for(cont;cont<dato.columnas.length;cont++){
                    dato.columnas[cont].medida_tablet = "";
                    dato.columnas[cont].layout_tablet = "";
                }
            }
            dato.fila.layout_tablet = value;
            vm.update();  
        } 
        vm.cambiarColumnasMobile = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length && cont<dato.columnas.length;cont++){
                var totalColumnas = 12;
                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
               
                dato.columnas[cont].medida_mobile = division;
                dato.columnas[cont].layout_mobile = partesSeparadas[cont];
            }
            if(partesSeparadas.length<dato.columnas.length){
                for(cont;cont<dato.columnas.length;cont++){
                    dato.columnas[cont].medida_mobile = "";
                    dato.columnas[cont].layout_mobile = "";
                }
            }
            dato.fila.layout_mobile = value;
            vm.update();  
        } 
        vm.selectedColumna = function(dato, selected){
            if(dato.fila.layout==selected){
                return "selected";
            }  
            return false;
        } 
        vm.selectedColumnaTablet = function(dato, selected){
            if(dato.fila.layout_tablet==selected){
                return "selected";
            }  
            return false;
        } 
        vm.selectedColumnaMobile = function(dato, selected){
            if(dato.fila.layout_mobile==selected){
                return "selected";
            }  
            return false;
        } 

        vm.modalInputsVar = "";
        vm.modalInput = function(columna){
            vm.modalInputsVar = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'inputs.html',
              size: 'lg',
              controller: function($scope) {
                $scope.listadoBloques = vm.listadoBloques;
                $scope.name = "";
                $scope.label = "";
                $scope.placeholder = "";
                $scope.tipo = "Input";
                $scope.texto = "";
                $scope.opciones = [];
                $scope.obligatorio = "";
                $scope.disabled = "";
                $scope.icon = "";
                $scope.enlace = "";
                $scope.labelenlace = "";
                $scope.fichero = "";
                $scope.dateformat = "dd-mm-yy";
                $scope.showed = {};
                $scope.showed.name = true;
                $scope.showed.label = true;
                $scope.showed.placeholder = true;
                $scope.showed.obligatorio = true;
                $scope.showed.disabled = false;
                $scope.showed.dateformat = false;
                $scope.showed.texto = false;
                $scope.showed.opciones = false;
                $scope.showed.primercampo = false;
                $scope.showed.type = false;
                $scope.showed.campotype = false;
                $scope.koForm = function(){
                    vm.modalInputsVar.close();
                }
                $scope.okForm = function(){
                    var inputVar = {};
                    inputVar.name = $scope.name;
                    inputVar.label = $scope.label;
                    inputVar.placeholder = $scope.placeholder;
                    inputVar.tipo = $scope.tipo;
                    inputVar.texto = $scope.texto;
                    inputVar.icon = $scope.icon;
                    inputVar.enlace = $scope.enlace;
                    inputVar.labelenlace = $scope.labelenlace;
                    inputVar.disabled = $scope.disabled;
                    inputVar.checkok = $scope.checkok;
                    inputVar.checkko = $scope.checkko;
                    inputVar.opciones = $scope.opciones;
                    inputVar.fichero = $scope.fichero;
                    inputVar.primercampo = $scope.primercampo;
                    inputVar.dateformat = $scope.dateformat;
                    inputVar.obligatorio = $scope.obligatorio;
                    inputVar.type = $scope.type;
                    inputVar.campotype = $scope.campotype;
                    columna.bloques.push(inputVar);
                    vm.update();
                    vm.modalInputsVar.close();
                }
                $scope.tipocampo = function(){
                    vm.tipoCampo($scope);
                }
                $scope.addValor = function(){
                    $scope.opciones.push({ "value" : '' });
                    //$scope.opciones.push({"width":0,"height":0});
                }
                $scope.borrarValor = function(index){
                    $scope.opciones.splice(index,1);
                }
              }
            });
        }

        vm.tipoCampo = function($scope){
            switch($scope.tipo){
                case "Checkbox":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.placeholder = false;
                    $scope.showed.icon = false;
                    $scope.showed.enlace = false;
                    $scope.showed.labelenlace = false;
                    $scope.showed.disabled = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = true;
                    $scope.showed.checkko = true;
                    $scope.showed.obligatorio = true;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "CheckboxEnlace":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.enlace = true;
                    $scope.showed.labelenlace = true;
                    $scope.showed.placeholder = false;
                    $scope.showed.disabled = false;
                    $scope.showed.icon = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = true;
                    $scope.showed.checkko = true;
                    $scope.showed.obligatorio = true;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "Submit":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.enlace = false;
                    $scope.showed.icon = true;
                    $scope.showed.disabled = false;
                    $scope.showed.labelenlace = false;
                    $scope.showed.placeholder = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.obligatorio = false;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "Texto":
                    $scope.showed.name = false;
                    $scope.showed.label = false;
                    $scope.showed.enlace = false;
                    $scope.showed.labelenlace = false;
                    $scope.showed.disabled = false;
                    $scope.showed.placeholder = false;
                    $scope.showed.icon = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.obligatorio = false;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = true;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "Hidden":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.enlace = false;
                    $scope.showed.labelenlace = false;
                    $scope.showed.disabled = false;
                    $scope.showed.placeholder = false;
                    $scope.showed.icon = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.obligatorio = false;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "Select":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.labelenlace = false;
                    $scope.showed.enlace = false;
                    $scope.showed.disabled = true;
                    $scope.showed.placeholder = false;
                    $scope.showed.primercampo = true;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.icon = false;
                    $scope.showed.obligatorio = true;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = true;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "SelectNode":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.labelenlace = false;
                    $scope.showed.enlace = false;
                    $scope.showed.disabled = true;
                    $scope.showed.placeholder = false;
                    $scope.showed.primercampo = true;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.icon = false;
                    $scope.showed.obligatorio = true;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = true;
                    $scope.showed.type = true;
                    $scope.showed.campotype = true;
                break;
                case "Fecha":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.enlace = false;
                    $scope.showed.labelenlace = false;
                    $scope.showed.disabled = false;
                    $scope.showed.placeholder = true;
                    $scope.showed.icon = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.obligatorio = true;
                    $scope.showed.dateformat = true;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                case "ListaCheckbox":
                case "ListaRadios":
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.labelenlace = false;
                    $scope.showed.enlace = false;
                    $scope.showed.disabled = false;
                    $scope.showed.placeholder = false;
                    $scope.showed.icon = false;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.obligatorio = true;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.opciones = true;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
                default:
                    $scope.showed.name = true;
                    $scope.showed.label = true;
                    $scope.showed.enlace = false;
                    $scope.showed.icon = false;
                    $scope.showed.labelenlace = false;
                    $scope.showed.disabled = false;
                    $scope.showed.placeholder = true;
                    $scope.showed.primercampo = false;
                    $scope.showed.checkok = false;
                    $scope.showed.checkko = false;
                    $scope.showed.dateformat = false;
                    $scope.showed.texto = false;
                    $scope.showed.obligatorio = true;
                    $scope.showed.opciones = false;
                    $scope.showed.type = false;
                    $scope.showed.campotype = false;
                break;
            }
        }

        vm.edit = function (bloque) {
             vm.modalInputsVar = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'inputs.html',
              size: 'lg',
              controller: function($scope) {
                $scope.listadoBloques = vm.listadoBloques;
                $scope.name = bloque.name;
                $scope.label = bloque.label;
                $scope.placeholder = bloque.placeholder;
                if(typeof bloque.texto != 'undefined'){
                    $scope.texto = bloque.texto;
                }else{
                    $scope.texto = "";
                }
                if(typeof bloque.primercampo != 'undefined'){
                    $scope.primercampo = bloque.primercampo;
                }else{
                    $scope.primercampo = "";
                }
                if(typeof bloque.opciones != 'undefined'){
                    $scope.opciones = bloque.opciones;
                }else{
                    $scope.opciones = [];
                }
                if(typeof bloque.icon != 'undefined'){
                    $scope.icon = bloque.icon;
                }else{
                    $scope.icon = "";
                }
                if(typeof bloque.enlace != 'undefined'){
                    $scope.enlace = bloque.enlace;
                }else{
                    $scope.enlace = "";
                }
                if(typeof bloque.labelenlace != 'undefined'){
                    $scope.labelenlace = bloque.labelenlace;
                }else{
                    $scope.labelenlace = "";
                }
                if(typeof bloque.disabled != 'undefined'){
                    $scope.disabled = bloque.disabled;
                }else{
                    $scope.disabled = "";
                }
                if(typeof bloque.checkok != 'undefined'){
                    $scope.checkok = bloque.checkok;
                }else{
                    $scope.checkok = "SI";
                }
                if(typeof bloque.checkko != 'undefined'){
                    $scope.checkko = bloque.checkko;
                }else{
                    $scope.checkko = "NO";
                }
                if(typeof bloque.type != 'undefined'){
                    $scope.type = bloque.type;
                }else{
                    $scope.type = "";
                }
                if(typeof bloque.campotype != 'undefined'){
                    $scope.campotype = bloque.campotype;
                }else{
                    $scope.campotype = "";
                }
                $scope.tipo = bloque.tipo;
                $scope.obligatorio = bloque.obligatorio;
                $scope.fichero = bloque.fichero;
                $scope.dateformat = bloque.dateformat;
                $scope.showed = {};
                $scope.showed.name = true;
                $scope.showed.icon = false;
                $scope.showed.enlace = false;
                $scope.showed.labelenlace = false;
                $scope.showed.label = true;
                $scope.showed.placeholder = true;
                $scope.showed.obligatorio = true;
                $scope.showed.disabled = false;
                $scope.showed.checkok = false;
                $scope.showed.checkko = false;
                $scope.showed.primercampo = false;
                $scope.showed.texto = false;
                $scope.showed.type = false;
                $scope.showed.campotype = false;
                $scope.koForm = function(){
                    vm.modalInputsVar.close();
                }
                $scope.okForm = function(){
                    console.log($scope.icon);
                    var inputVar = {};
                    bloque.name = $scope.name;
                    bloque.label = $scope.label;
                    bloque.placeholder = $scope.placeholder;
                    bloque.primercampo = $scope.primercampo;
                    bloque.enlace = $scope.enlace;
                    bloque.labelenlace = $scope.labelenlace;
                    bloque.tipo = $scope.tipo;
                    bloque.texto = $scope.texto;
                    bloque.icon = $scope.icon;
                    bloque.opciones = $scope.opciones;
                    bloque.fichero = $scope.fichero;
                    bloque.obligatorio = $scope.obligatorio;
                    bloque.disabled = $scope.disabled;
                    bloque.checkok = $scope.checkok;
                    bloque.checkko = $scope.checkko;
                    bloque.dateformat = $scope.dateformat;
                    bloque.type = $scope.type;
                    bloque.campotype = $scope.campotype;
                    vm.update();
                    vm.modalInputsVar.close();
                }
                $scope.tipocampo = function(){
                    vm.tipoCampo($scope);
                }
                $scope.addValor = function(){
                    $scope.opciones.push("");
                }
                $scope.borrarValor = function(index){
                    $scope.opciones.splice(index,1);
                }
              }
            });
        }

    } 

})();